"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.protoEncodeAuthInfoV2 = void 0;
var long_1 = __importDefault(require("long"));
var codec_1 = require("../../../cosmos/v1beta1/codec");
var bytes_1 = require("../../bytes/bytes");
var v2_signable_1 = require("../../../transaction/v2.signable");
exports.protoEncodeAuthInfoV2 = function (authInfo) {
    var encodableAuthInfo = {
        signerInfos: authInfo.signerInfos.map(function (_a) {
            var publicKey = _a.publicKey, modeInfo = _a.modeInfo, sequence = _a.sequence;
            return ({
                publicKey: protoEncodePubKey(publicKey),
                modeInfo: modeInfo,
                sequence: sequence ? long_1.default.fromString(sequence.toString()) : undefined,
            });
        }),
        fee: {
            amount: authInfo.fee.amount !== undefined
                ? authInfo.fee.amount.map(function (feeAmount) { return feeAmount.toCosmosCoin(); })
                : [],
            gasLimit: protoEncodeGasLimitOrDefaultV2(authInfo),
        },
    };
    return bytes_1.Bytes.fromUint8Array(codec_1.cosmos.tx.v1beta1.AuthInfo.encode(encodableAuthInfo).finish());
};
var protoEncodeGasLimitOrDefaultV2 = function (authInfo) {
    var defaultGasLimit = long_1.default.fromNumber(v2_signable_1.DEFAULT_GAS_LIMIT);
    return authInfo.fee.gasLimit !== undefined && authInfo.fee.gasLimit !== null
        ? long_1.default.fromNumber(authInfo.fee.gasLimit.toNumber())
        : defaultGasLimit;
};
var protoEncodePubKey = function (pubKey) {
    var pubKeyProto = codec_1.cosmos.crypto.secp256k1.PubKey.create({
        key: pubKey.toUint8Array(),
    });
    return codec_1.google.protobuf.Any.create({
        type_url: '/cosmos.crypto.secp256k1.PubKey',
        value: Uint8Array.from(codec_1.cosmos.crypto.secp256k1.PubKey.encode(pubKeyProto).finish()),
    });
};
//# sourceMappingURL=v2.authInfo.js.map